import { Request } from '@/classes/Request'

/**
 * Tokenize + store a VeriCheck bank account for the invited family,
 * token-authenticated. Payload shape matches VericheckFormDialog's save payload
 * so it can be passed as the dialog's :save-handler.
 * POST /api/enrollment/invitation/{token}/funding-sources/bank-account
 */
export const enrollmentAddBankAccount = async (token: string, payload: object): Promise<void> => {
  await new Request().post(
    `/api/enrollment/invitation/${encodeURIComponent(token)}/funding-sources/bank-account`,
    payload
  )
}
